// Safari (as of 17.x) implements ReadableStream but does not expose
// Symbol.asyncIterator on it, so `for await (const chunk of stream)` throws
// "undefined is not a function". spacetimedb's gzip/brotli response decoder
// relies on this pattern, which breaks reducer responses in Safari.
//
// This shim adds the spec-defined async iterator using the public reader API.
// It's a no-op on Chrome/Firefox, which already implement it natively.

if (
  typeof ReadableStream !== "undefined" &&
  !(ReadableStream.prototype as unknown as AsyncIterable<unknown>)[Symbol.asyncIterator]
) {
  (ReadableStream.prototype as unknown as { [Symbol.asyncIterator]: () => AsyncIterator<unknown> })[
    Symbol.asyncIterator
  ] = function (this: ReadableStream<unknown>) {
    const reader = this.getReader();
    return {
      next() {
        return reader.read() as Promise<IteratorResult<unknown>>;
      },
      return() {
        reader.releaseLock();
        return Promise.resolve({ value: undefined, done: true });
      },
      [Symbol.asyncIterator]() {
        return this;
      },
    };
  };
}
